export function getEnvData(key) {
    console.log(key, process.env, process.env[key])
    return process.env[key]
}